import { useEffect, useState, useRef } from "react";
 
const UseGoogleAuthCode = () => {
    const [tokenResponse, setTokenResponse] = useState(null);
    const [failed, setFailed] = useState({ status: false, message: "" });
 
    const popupRef = useRef(null); // 🧠 Keep reference to popup
    const popupMonitorIntervalRef = useRef(null); // Monitor popup status
 
    const googleOAuthLogin = () => {
        popupRef.current = null;
 
        setFailed({ status: false, message: "" });
        setTokenResponse(null);
       
        const width = 500;
        const height = 600;
        const left = window.screen.width / 2 - width / 2;
        const top = window.screen.height / 2 - height / 2;
 
        const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;
        const redirectUri = process.env.REACT_APP_GOOGLE_REDIRECT_URI;
 
        const oauthUrl =
            `https://accounts.google.com/o/oauth2/v2/auth?` +
            `client_id=${clientId}` +
            `&redirect_uri=${encodeURIComponent(redirectUri)}` +
            `&response_type=code` +
            `&scope=${encodeURIComponent(
                "openid profile email https://www.googleapis.com/auth/calendar.events"
            )}` +
            `&access_type=offline` +
            `&prompt=consent`;
 
        const popup = window.open(
            oauthUrl,
            "_blank",
            `width=${width},height=${height},top=${top},left=${left}`
        );
 
        if (!popup) {
            setFailed({ status: true, message: "Popup blocked. Please enable popups for this site." });
            return;
        }
 
        popupRef.current = popup;
 
        popupMonitorIntervalRef.current = setInterval(() => {
            if (popup && popup.closed) {
                clearInterval(popupMonitorIntervalRef.current);
                setFailed({ status: true, message: "Popup closed before completing login." });
            }
        }, 500);
    };
 
    useEffect(() => {
        // 💡 Clear any stale auth data when component mounts
        const code = localStorage.getItem("google_oauth_code");
        const error = localStorage.getItem("google_oauth_error");
 
        if (code) localStorage.removeItem("google_oauth_code");
        if (error) localStorage.removeItem("google_oauth_error");
 
        const interval = setInterval(() => {
            const newCode = localStorage.getItem("google_oauth_code");
            const newError = localStorage.getItem("google_oauth_error");
 
            if (newCode) {
                localStorage.removeItem("google_oauth_code");
                setTokenResponse(newCode);
                clearInterval(interval);
            } else if (newError) {
                localStorage.removeItem("google_oauth_error");
                setFailed({ status: true, message: newError });
                clearInterval(interval);
            }
        }, 500);
 
        return () => clearInterval(interval);
    }, []);
 
    return { login: googleOAuthLogin, tokenResponse, failed };
};
 
export default UseGoogleAuthCode;